import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AuditFilters = ({ filters, onFilterChange, filterOptions, onReset }) => {
  const handleChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const entityTypeOptions = [
    { value: '', label: 'All Entity Types' },
    ...(filterOptions?.entityTypes || [])?.map(type => ({
      value: type,
      label: type
    }))
  ];

  const actionTypeOptions = [
    { value: '', label: 'All Action Types' },
    ...(filterOptions?.actionTypes || [])?.map(type => ({
      value: type,
      label: type
    }))
  ];

  const performerOptions = [
    { value: '', label: 'All Performers' },
    ...(filterOptions?.performers || [])?.map(performer => ({
      value: performer,
      label: performer
    }))
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-base text-foreground">
            Filters
          </h3>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={onReset}
          iconName="X"
          iconPosition="left"
        >
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label="Entity Type"
          options={entityTypeOptions}
          value={filters?.entityType || ''}
          onChange={(value) => handleChange('entityType', value)}
        />

        <Select
          label="Action Type"
          options={actionTypeOptions}
          value={filters?.actionType || ''}
          onChange={(value) => handleChange('actionType', value)}
        />

        <Select
          label="Performed By"
          options={performerOptions}
          value={filters?.performedBy || ''}
          onChange={(value) => handleChange('performedBy', value)}
        />

        <Input
          label="Date From"
          type="date"
          value={filters?.dateFrom || ''}
          onChange={(e) => handleChange('dateFrom', e?.target?.value)}
        />

        <Input
          label="Date To"
          type="date"
          value={filters?.dateTo || ''}
          onChange={(e) => handleChange('dateTo', e?.target?.value)}
        />

        <Input
          label="Search"
          type="text"
          placeholder="Search actions, users, entities..."
          value={filters?.searchTerm || ''}
          onChange={(e) => handleChange('searchTerm', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default AuditFilters;